import {getCarrierCode, lowerCase, wordsToUnderScore} from "../../../../utils/commonUtils";
import numeral from "numeral";
import {getEmployerAndParticipantCont} from "../../Enrollment/EnrollmentHome/EnrollmentApplication/Utilities";
import * as EstimatorActions from "../../../../actions/estimator";
import {useActions} from "../../../../actions";
import * as React from "react";
import {useState} from "react";
import * as EstimationActions from "../../../../actions/estimation";

export const InvestmentValues = {
    SP500: "S&P500",
    lowVolatility: "lowVolatility",

    SP500Futures: "SP500Futures",
    SP500ALZ: "S&P500ALZ", // its default for if user atlantic and Allianz
    lowVolatilityALZ: "lowVolatilityALZ",
    Conservative: "Conservative",
    Moderate: "Moderate",
    Aggressive: "Aggressive",
    ConservativePlus: "ConservativePlus",
    ModeratePlus: "ModeratePlus",
    AggressivePlus: "AggressivePlus",
};

export const isSuffixExist  = (str) =>{
    return !!InvestmentValues[str+"Plus"]
}

export function getInvestmentValue(str: keyof typeof InvestmentValues) {
   return  checkSuffixPlus( str) ? str.substring(0,str.length - 4) : str
}
export const checkSuffixPlus = (str:any, suffix= 'Plus') =>{

    // Check if either string is null or empty
    if (((str === null) || (str === '')) || ((suffix === null) || (suffix === '')))
    {
        return false; // Return false if either string is null or empty
    }
    else
    {
        // Convert both strings to type string
        str = str.toString();
        suffix = suffix.toString();
    }
    // Check if the suffix is found at the end of the string
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
}
export const InvestmentValuesLabel = {
    [InvestmentValues.SP500]: "S&P 500",
    [InvestmentValues.lowVolatility]: "low Volatility",
    [InvestmentValues.SP500ALZ]: "S&P Annual PtP",
    [InvestmentValues.lowVolatilityALZ]: "BUDBI Classic",
    [InvestmentValues.Conservative]: "Conservative",
    [InvestmentValues.Moderate]: "Moderate",
    [InvestmentValues.SP500Futures]: "S&P Futures",
    [InvestmentValues.Aggressive]: "Aggressive",
    [InvestmentValues.ConservativePlus]: "Conservative PLUS",
    [InvestmentValues.ModeratePlus]: "Moderate PLUS",
    [InvestmentValues.AggressivePlus]: "Aggressive PLUS",
    "custom": "Custom",
};

/**
 * This is the mapper for allocation questions.
 * Must add new default allocations here.
 */
export const allocationMapper = {
    [InvestmentValues.SP500]: ["SP500PointToPointCapFocus"],
    [InvestmentValues.lowVolatility]: ["BalancedTrendIndexPointToPointNoCap", "USPacesetterIndexPointtoPointNoCap"],
    [InvestmentValues.SP500ALZ]: ["7"],
    [InvestmentValues.SP500Futures]: ["130"],
    [InvestmentValues.lowVolatilityALZ]: ["100"],
    [InvestmentValues.Conservative]: ["101", "131", "130", "129"],
    [InvestmentValues.Moderate]: ["77", "128", "127", "126"],
    [InvestmentValues.Aggressive]: ["86", "125", "124", "123"],
    [InvestmentValues.ConservativePlus]: ["101", "131", "129", "130", "3"],
    [InvestmentValues.ModeratePlus]: ["77", "128", "127", "126", "3"],
    [InvestmentValues.AggressivePlus]: ["86", "125", "124", "123", "3"],
}

// export const allocationsMapperWithCarrier = {
//     3:  ["101", "131", "129", "130", "3", "77", "128", "127", "126", "86", "125", "124", "123"],
//     2:  ["SP500PointToPointCapFocus", "BalancedTrendIndexPointToPointNoCap", "USPacesetterIndexPointtoPointNoCap"]
// }

export const allocationsMapperWithCarrierLabels = {
    3:  ["101", "131", "130", "123", "5", "7", "47", "3"],
    2:  ["SP500PointToPointCapFocus", "SP500PointToPointParFocus", "SP500PointToPointOnePercentFloor", "BalancedTrendIndexPointToPointNoCap", "USPacesetterIndexPointtoPointNoCap", "FixedTermStrategy"]
}



const  percentage = "percentage"
const  bonusFieldPrefix = "bonus"
const  growthFieldPrefix = "growth"
export const allocationFieldForm = "allocationQuestions";
export const customInvestmentTypeFieldName = "isCustomInvestmentType"

export const getPercentageName = (code:string) =>{
    return `${percentage}_${code}`
}

export const getPercentageNameWithLabel = (label:string) =>{
    return `${percentage}_${label}`
}

export const getPercentageFieldName = (doHaveBonus: boolean, label: string, code: string) => {
    const percentageCol = doHaveBonus ? `${label}_${code}` : `${label}`;
    return lowerCase(wordsToUnderScore(percentageCol));
}

export const getCurrentGrowthLabel = (label:string) =>{
    return `${growthFieldPrefix}_${label}`
}

export const getGrowthFieldName = (label: string, code: string) => {
    return lowerCase(wordsToUnderScore(`${growthFieldPrefix}_${label}_${code}`))
}

export const getBonusFieldName = (code:string) =>{
    return `${bonusFieldPrefix}_${code}`
}
export const getBonusFieldNameWithLabel = (label:string) =>{
    return `${bonusFieldPrefix}_${label}`
}

export const getBonusFieldNameWithLabelPostfix = (label: string, id: string, bonusType: number) => {
    return lowerCase(wordsToUnderScore(`${label}_${id}_${bonusType}`))
}

export const getCodeFromLabelAndBonus = (allocationQuestions:object) => {
   return (label:string , bonus:string):any=>{
      const data =  Object.keys(allocationQuestions).find((key)=>{
            const question = allocationQuestions[key]
            return (question["label"] == label && question["bonusType"] == bonus)
       })
       return data
   }
}

export const createAllocationObject = (values) =>{
    const allocationQuestion = values[allocationFieldForm]
    const getCode = getCodeFromLabelAndBonus(allocationQuestion)
    const questions: any = allocationsMapperWithCarrierLabels[values.primaryCarrier];
    const result:any = []
    questions && questions.forEach((code) => {
        const label =  (allocationQuestion && allocationQuestion[code] &&  allocationQuestion[code].label) || ""
        if(allocationQuestion && allocationQuestion[code] && values[getPercentageNameWithLabel(label)]){
            result.push({
                questionCode: getCode(label, values[getBonusFieldNameWithLabel(label)]),
                bonus: values[getBonusFieldNameWithLabel(label)] || 0,
                percentage: values[getPercentageNameWithLabel(label)],
            })
        }
    })
    return result
}

export const createDynamicAllocationObject = (values) => {
    const allocationQuestion = values[allocationFieldForm]
    const result: any = [];
    if (allocationQuestion && typeof allocationQuestion === "object") {
        (Object.values(allocationQuestion) as any[]).forEach(({doHaveBonus, bonusType, code}) => {
            const label = (allocationQuestion[code] && allocationQuestion[code].label) || "";
            const percentageName = getPercentageFieldName(doHaveBonus, label, code);

            if (values[percentageName]) {
                result.push({
                    questionCode: code,
                    bonus: bonusType || 0,
                    percentage: values[percentageName]
                });
            }
        });
    }
    return result
}


export const createInitialValues = (values, savedAllocations, carrier) =>{
    const allocationQuestion = values[allocationFieldForm]
    const getLabel = (code) =>{
        return  (allocationQuestion[code] &&  allocationQuestion[code].label) || ""
    }
    console.log(allocationQuestion, "allocationQuestion")
    const initialValues:any = {}
    if(allocationQuestion){
        const questions: any = allocationsMapperWithCarrierLabels[carrier];
        let label:string;
        const getCode = getCodeFromLabelAndBonus(allocationQuestion)
        initialValues["totalPercentage"] = 100
        savedAllocations && savedAllocations.forEach((allocation) => {
            const code  = allocation.allocationname
            label = getLabel(code)
            initialValues[getPercentageNameWithLabel(label)] = allocation.allocationweight
            if(allocationQuestion[code] &&  allocationQuestion[code].doHaveBonus){
                initialValues[getBonusFieldNameWithLabel(getLabel(code))] = allocationQuestion[code] && allocationQuestion[code].bonusType
            }
            initialValues[getBonusFieldNameWithLabel(getLabel(code))] = allocationQuestion[code] && allocationQuestion[code].bonusType
            const ClientCode = getCode(getLabel(code), allocationQuestion[code] && allocationQuestion[code].bonusType)
            initialValues[getCurrentGrowthLabel(getLabel(ClientCode))] = allocationQuestion[ClientCode] && allocationQuestion[ClientCode].percentage
            // initialValues[getBonusFieldNameWithLabel(label)] = allocation.bonus
        })
        // set other values to null
        questions && questions.forEach((code) => {
            label =  getLabel(code)
            if(!initialValues[getPercentageNameWithLabel(label)]){
                initialValues[getPercentageNameWithLabel(label)] = ""
            }
            if(!initialValues[getBonusFieldNameWithLabel(label)]){
                initialValues[getBonusFieldNameWithLabel(label)] = null
            }
            const ClientCode = getCode(getLabel(code), allocationQuestion[code] && allocationQuestion[code].bonusType)
            if(!initialValues[getCurrentGrowthLabel(getLabel(ClientCode))]){
                initialValues[getCurrentGrowthLabel(getLabel(ClientCode))] = allocationQuestion[ClientCode] && allocationQuestion[ClientCode].percentage
            }
        })
    }
    return initialValues
}
// create riders data to send with json on final illustration
export const createLivingBenefits = (livingBenefits: number[]) =>{
    // these are id of living benefits in database
    const defaultValues = [1,2,3,4,5]
    const result:any = {}
    defaultValues.forEach((item, index) => {
        result[livingBenefitsAbstractedValues[item].value] = livingBenefits.includes(item) ? "Yes" : "No"
    })
    return result
}
// living benefit data save save in the riders in stress response we have to extract it from stress response for use
type YesNo = "Yes" | "No";
type RidersType = Record<
    "chronicillness" | "criticalillness" | "criticalinjury" | "terminalillness" | "alzheimers",
    YesNo
>;
export const createLivingBenefitsFromRiders = (riders: RidersType) =>{
    const result:any = []
    for (const key in livingBenefitsAbstractedValues) {
        if(riders[livingBenefitsAbstractedValues[key].value] == "Yes"){
            result.push(key)
        }
    }
    return result
}
// keys are representing id of row of table LivingBenefits and name for representing values to send in estimator json
export const livingBenefitsAbstractedValues = {
    "1": {value: "chronicillness", name: "Chronic Illness"},
    "2": {value: "criticalillness", name: "Critical Illness"},
    "3": {value: "criticalinjury", name: "Critical Injury"},
    "4": {value: "terminalillness", name: "Terminal Illness"},
    "5": {value: "alzheimers", name: "Alzheimer’s"}
}

export const carrierRiders = {
    "3" :[1, 4],
    "2" :[1, 2, 3, 4, 5]
}

// hook to get allocation from strategy id and carrier id
export function useGetAllocation(strategyId: number, carrierId: number) {
    const estimatorActions = useActions(EstimatorActions);
    const [allocationQuestion, setAllocationQuestion] = useState({});
    const estimationActions = useActions(EstimationActions);
    const getEstimatorDataFromApi = async (query: Partial<{ strategyId: number, carrierId: number }>) => {
        if (query.carrierId && query.strategyId) {
            const res = await estimatorActions.getEstimatorDetails(query);
            if (!!res) {
                return res.id
            }
        }
    };
    React.useEffect(() => {
        (async () => {
           const estimatorDataId =  await getEstimatorDataFromApi({ strategyId, carrierId})
            if (estimatorDataId) {
                const res = await estimationActions.getAllocationQuestions({
                    estimatorId: estimatorDataId,
                    carrierId: carrierId,
                });
                if (res) {
                    const allocationValues = {};
                    res.forEach((fields) => {
                        allocationValues[fields.code] = fields;
                    });
                    setAllocationQuestion(allocationValues);
                }
            }
        })();

    }, [strategyId, carrierId]);

    return allocationQuestion;
}

export const getAllocationPayloadForAdmin = (values:any, carrier: number, allocation?: any) =>{
    let allocationQuestion = values[allocationFieldForm]
    if(!allocationQuestion){
        allocationQuestion = allocation
    }
    const getCode = getCodeFromLabelAndBonus(allocationQuestion)
    const questions: any = allocationsMapperWithCarrierLabels[carrier];
    const result:any = []
    questions && questions.forEach((code) => {
        const label =  (allocationQuestion && allocationQuestion[code] &&  allocationQuestion[code].label) || ""
        if(allocationQuestion && allocationQuestion[code] && values[getPercentageNameWithLabel(label)]){
            result.push({
                "allocationname": getCode(label, values[getBonusFieldNameWithLabel(label)]),
                "allocationrate": values[getCurrentGrowthLabel(label)],
                "allocationweight": values[getPercentageNameWithLabel(label)],
            })
        }
    })
    console.log(result, "====")
    return [{
        "allocations":result,
        "from": "1",
        "through": "M"
    }]
}

export const checkLabelExist = (allocations:any,codes:number[], label:string) =>{
    for (let i = 0; i < codes.length; i++) {
        const code = codes[i];
        if(allocations[code] && allocations[code].label == label){
            return allocations[code]
        }
    }
    return false

}


export const allocationIndexs = {
    "41": {
        desc:"",
    },
    "86" : {
        desc:"The PIMCO Tactical Balanced ER Index comprises two underlying components that shift weights daily based on historical realized volatility. The first component is U.S. Equity Futures Custom Index, which tracks futures on large-cap equities, similar to futures on the S&P 500. The second component is PIMCO Synthetic Bond ER which is a custom index made up of a small number of instruments dsigned to provide exposure to futures on U.S. investment-grade and Treasure bond markets. The Select bonus multiplies anyu annual indexed interest by 40% but also includes a 1% annual asset charge. This bonus is designed for clients who are willing to pay a charge in return for a higher bonus and greater indexed interest potential.",
    },
    "66":{
        desc:"",
    },
    "77":{
        desc:"The PIMCO Tactical Balanced ER Index comprises two underlying components that shift weights daily based on historical realized volatility. The first component is U.S. Equity Futures Custom Index, which tracks futures on large-cap equities, similar to futures on the S&P 500. The second component is PIMCO Synthetic Bond ER which is a custom index made up of a small number of instruments dsigned to provide exposure to futures on U.S. investment-grade and Treasure bond markets. The Bonused bonus multiplies any annual indexted interest by 15%. This bonus is designed for clients looking for a moderate choice with bonus potential but no charges associated with the bonus.",
    },
    "102":{
        desc:"",
    },
    "101":{
        desc:"The PIMCO Tactical Balanced ER Index comprises two underlying components that shift weights daily based on historical realized volatility. The first component is U.S. Equity Futures Custom Index, which tracks futures on large-cap equities, similar to futures on the S&P 500. The second component is PIMCO Synthetic Bond ER which is a custom index made up of a small number of instruments dsigned to provide exposure to futures on U.S. investment-grade and Treasure bond markets. The Classic bonus provides a 1% guaranteed bonus to the policy's current value - designed for clients who may want a conservative approach and a guaranteed credit.",
    },
    "7":{
        desc:"The S&P 500 Index represents a broad cross-section of common stocks traded on every major U.S. stock exchange. The index is a selection of 500 leading companies from 100 distinct industry groups found in 10 leading American industrial market sectors. The point-to-point crediting method traches changes in the index value through the policy year; if there is a positive change in the index value from the previous year, the policy is credited with any earned interest subject to a cap or participation rate, and if there is a negative change, the indexed interest for that year will be zero.",
    },
    "5":{
    desc:"The S&P 500 Index represents a broad cross-section of common stocks traded on every major U.S. stock exchange. The index is a selection of 500 leading companies from 100 distinct industry groups found in 10 leading American industrial market sectors. The monthly sum crediting method tracks the monthly changes in an index, subject to a cap. At the end of each year, the 12 monthly changes (positive and negative) are added up; if the total is positive, this is credited to the policy, and if negative the indexed interest for that year will be zero."
    },
    "47":{
    desc:"The S&P 500 Index represents a broad cross-section of common stocks traded on every major U.S. stock exchange. The index is a selection of 500 leading companies from 100 distinct industry groups found in 10 leading American industrial market sectors. The trigger method tracks changes in the index value throught the the policy year, and any change in the in the index's value that is greater than or equal to zero will trigger a predetermined interest rate - the Trigger Interest Rate - to be credited to the policy (e.g., if the Trigger Interest Rate is 5%, and the index returned 2.5%, youd be credited with 5%). Negative changes would credit 0%"
    },
    "18":{
        desc:""
    },
    "80":{
        desc:"The PIMCO Tactical Balanced ER Index comprises two underlying components that shift weights daily based on historical realized volatility. The first component is U.S. Equity Futures Custom Index, which tracks futures on large-cap equities, similar to futures on the S&P 500. The second component is PIMCO Synthetic Bond ER which is a custom index made up of a small number of instruments dsigned to provide exposure to futures on U.S. investment-grade and Treasure bond markets."
    },
    "3":{
        desc:"The fixed interest rate can give you the assurance of a predictavle interest credit in volatile or even down markets. Allocating a portion of your assets to the fixed account can help diversify and provide a level of certainty within your portfolio. "
    },
    "125":{
        desc:"The Blended Futures Index is a non-volatility-controlled index that is constructed by allocating to futures indexes in fixed percentages to proved a 60/40 mix between equity and bond indexes. The components of the Blended Futures Index use an excess return methodology by tracking the proce of futures. Futures prices reflect the expected future proced of an index and account for expected dividends. The Select bonus multiplies anyu annual indexed interest by 40% but also includes a 1% annual asset charge. This bonus is designed for clients who are willing to pay a charge in return for a higher bonus and greater indexed interest potential."
    },
    "124":{
        desc:"The S&P 500 Futures Index ER is constructed from the front-quarter E-mini futures contract on the S&P 500. It tracks three-month futures on teh S&P 500 Index. The S&P 500 Futures Inex ER uses an excess return methodology by tracking the price of futures. Futures prices reflect the expected future price of an index and account for expected dividends. The Select bonus multiplies anyu annual indexed interest by 40% but also includes a 1% annual asset charge. This bonus is designed for clients who are willing to pay a charge in return for a higher bonus and greater indexed interest potential."
    },
    "123":{
        desc:"The Bloomberg US Dynamic Balance III ER Index is comprised of varying exposure to the Bloomberg US Equity Futures Basket ER Index, which is comprised of three sub-indexes: the Bloomberg US Equity Custom Futures ER Index, the Bloomberg US Small Cap Custom Futures ER Index, and the Bloomberg NDX Equity Custom Futres ER Index, with weights of 80%, 10%, and 10%, respectively. These sub-indexes are rebalanced daily. The Select bonus multiplies anyu annual indexed interest by 40% but also includes a 1% annual asset charge. This bonus is designed for clients who are willing to pay a charge in return for a higher bonus and greater indexed interest potential."
    },
    "128":{
        desc:"The Blended Futures Index is a non-volatility-controlled index that is constructed by allocating to futures indexes in fixed percentages to proved a 60/40 mix between equity and bond indexes. The components of the Blended Futures Index use an excess return methodology by tracking the proce of futures. Futures prices reflect the expected future proced of an index and account for expected dividends. The Bonused bonus multiplies any annual indexted interest by 15%. This bonus is designed for clients looking for a moderate choice with bonus potential but no charges associated with the bonus."
    },
    "127": {
        desc: "The S&P 500 Futures Index ER is constructed from the front-quarter E-mini futures contract on the S&P 500. It tracks three-month futures on teh S&P 500 Index. The S&P 500 Futures Inex ER uses an excess return methodology by tracking the price of futures. Futures prices reflect the expected future price of an index and account for expected dividends."
    },
    "126": {
        desc: "The Bloomberg US Dynamic Balance III ER Index is comprised of varying exposure to the Bloomberg US Equity Futures Basket ER Index, which is comprised of three sub-indexes: the Bloomberg US Equity Custom Futures ER Index, the Bloomberg US Small Cap Custom Futures ER Index, and the Bloomberg NDX Equity Custom Futres ER Index, with weights of 80%, 10%, and 10%, respectively. These sub-indexes are rebalanced daily. The Bonused bonus multiplies any annual indexted interest by 15%. This bonus is designed for clients looking for a moderate choice with bonus potential but no charges associated with the bonus."
    },
    "131": {
        desc: "The Blended Futures Index is a non-volatility-controlled index that is constructed by allocating to futures indexes in fixed percentages to proved a 60/40 mix between equity and bond indexes. The components of the Blended Futures Index use an excess return methodology by tracking the proce of futures. Futures prices reflect the expected future proced of an index and account for expected dividends. The Classic bonus provides a 1% guaranteed bonus to the policy's current value - designed for clients who may want a conservative approach and a guaranteed credit."
    },
    "130": {
        desc: "The S&P 500 Futures Index ER is constructed from the front-quarter E-mini futures contract on the S&P 500. It tracks three-month futures on teh S&P 500 Index. The S&P 500 Futures Inex ER uses an excess return methodology by tracking the price of futures. Futures prices reflect the expected future price of an index and account for expected dividends. The Classic bonus provides a 1% guaranteed bonus to the policy's current value - designed for clients who may want a conservative approach and a guaranteed credit."
    },
    "129": {
        desc: "The Bloomberg US Dynamic Balance III ER Index is comprised of varying exposure to the Bloomberg US Equity Futures Basket ER Index, which is comprised of three sub-indexes: the Bloomberg US Equity Custom Futures ER Index, the Bloomberg US Small Cap Custom Futures ER Index, and the Bloomberg NDX Equity Custom Futres ER Index, with weights of 80%, 10%, and 10%, respectively. These sub-indexes are rebalanced daily. The Classic bonus provides a 1% guaranteed bonus to the policy's current value - designed for clients who may want a conservative approach and a guaranteed credit."
    },
    "FixedTermStrategy": {
        desc: "The Fixed Account credits daily at a fixed rate declared by the insurance carrier and guaranteed for one year. "
    },
    "SP500PointToPointCapFocus": {
        desc:"The S&P 500® is widely regarded as the best single gauge of the U.S. equities market. This world-renowned index includes a representative sample of 500 leading companies in leading industries of the U.S. economy. Although the S&P 500® focuses on the large-cap segment of the market it is also an ideal representative for the total market."
    },
    "SP500PointToPointParFocus": {
        desc:"The S&P 500® is widely regarded as the best single gauge of the U.S. equities market. This world-renowned index includes a representative sample of 500 leading companies in leading industries of the U.S. economy. Although the S&P 500® focuses on the large-cap segment of the market it is also an ideal representative for the total market."
    },
    "SP500PointToPointOnePercentFloor": {
        desc:"The S&P 500® is widely regarded as the best single gauge of the U.S. equities market. This world-renowned index includes a representative sample of 500 leading companies in leading industries of the U.S. economy. Although the S&P 500® focuses on the large-cap segment of the market it is also an ideal representative for the total market."
    },
    "BalancedTrendIndexPointToPointNoCap": {
        desc:"This is a volatility-targeted Indexed Crediting Strategy whose returns are based on an index of a global multi-asset investment universe comprised of equities, bonds, real estate, commodities and cash. The Index is rebalanced daily to limit up or down volatility."
    },
    "USPacesetterIndexPointtoPointNoCap": {
        desc:"The US Pacesetter Index, provided by Société Générale, is a US-focused volatility targeted index. It seeks to provide less volatility than the highs and lows of the general market through a mix of different asset classes that cover exposure to US equities, US government debt, and commodities within the agriculture, metals, and energy sectors."
    }
}

export const bonusLabels = {
    1: { code: "select" , label: "Select"},
    2: { code: "classic" , label: "Classic"},
    3: { code: "standard" , label: "Standard"},
    4: { code: "bonus" , label: "Bonus"},
}
export const IsCustomAllocations = "CUSTOM"

export const addSuffixInfo = (str:string, code: string) =>{
    const concatenator = "?"
    const strArr = str.split(concatenator)
    if(!strArr.includes(code)){
        return str + concatenator + code
    }
    return str
}

export const hasCode = (str: string, code: string): boolean => {
    if(typeof str !== 'string'){
        return false
    }
    const concatenator = "?"
    const strArr = str.split(concatenator);
    return strArr.includes(code);
};

export const removeSuffixInfo = (str: string): string => {
    if(typeof str !== 'string'){
     return str
    }
    const idx = str.indexOf('?');
    return idx !== -1 ? str.slice(0, idx) : str;
};

export const addPlus = (plus, code) =>{
     if(plus && InvestmentValues[code+"Plus"]){
        return code+"Plus"
     }
     return code
}

export const overRideLabels = {
    // [InvestmentValues.ConservativePlus]: {
    //         "101": "20% PIMCO (1% Bonus)",
    //         "131": "20% Blended Futures (1% Bonus)",
    //         "130": "20% S&P Futures (1% Bonus)",
    //         "129": "20% BUDBI (1% Bonus)",
    //         "3": "20% Fixed Account"
    // },
    // [InvestmentValues.ModeratePlus]: {
    //     "77": "20% PIMCO (15% Multiplier)",
    //     "128": "20% Blended Futures (15% Multiplier)",
    //     "127": "20% S&P Futures (15% Multiplier)",
    //     "126": "20% BUDBI (15% Multiplier)",
    //     "3": "20% Fixed Account"
    // },
    // [InvestmentValues.AggressivePlus]: {
    //     "86": "20% PIMCO Select (40% Multiplier)",
    //     "125": "20% Blended Futures Select (40% Multiplier)",
    //     "124": "20% S&P Futures Select (40% Multiplier)",
    //     "123": "20% BUDBI Select (40% Multiplier)",
    //     "3": "20% Fixed Account"
    // },
    // [InvestmentValues.SP500ALZ]: {
    //     "130": "S&P 500® Futures (1% Bonus)"
    // }

}

// these used on Assumptions for statically show question to avoid the fetch request on Assumptions do not use it
export const allocationQuestions = {
    [InvestmentValues.SP500]: {
        codes:["SP500PointToPointCapFocus"],
        labels: ["S&P 500 Point to Point Cap Focus"]
    },
    [InvestmentValues.lowVolatility]: {
        codes:["BalancedTrendIndexPointToPointNoCap", "USPacesetterIndexPointtoPointNoCap"],
        labels: ["Credit Suisse", "Pacesetter"]
    },
    [InvestmentValues.lowVolatilityALZ]: {
        codes:["100"],
        labels: ["BUDBI Classic 0.90% Guaranteed Bonus No Additional Charge"]
    },
    [InvestmentValues.SP500ALZ]: {
        codes:["130"],
        labels: ["S&P 500® Futures"]
    },
    [InvestmentValues.Conservative]: {
        codes:["101", "131", "130", "129"],
        labels: ["PIMCO (1% Bonus)", " Blended Futures (1% Bonus)", " S&P Futures (1% Bonus))", " BUDBI III (1% Bonus)"]
    },
    [InvestmentValues.ConservativePlus]: {
        codes:["101", "131", "129", "130", "3"],
        labels: ["PIMCO (1% Bonus)", " Blended Futures (1% Bonus)", " S&P Futures (1% Bonus))", " BUDBI (1% Bonus)", " Fixed Allocations"]
    },
    [InvestmentValues.Moderate]: {
        codes:["77", "128", "127", "126"],
        labels: ["PIMCO (15% Multiplier)", " Blended Futures (15% Multiplier)", " S&P Futures (15% Multiplier)", " BUDBI (15% Multiplier)"]
    },
    [InvestmentValues.ModeratePlus]: {
        codes:["77", "128", "127", "126", "3"],
        labels: ["PIMCO (15% Multiplier)", " Blended Futures (15% Multiplier)", " S&P Futures (15% Multiplier)", " BUDBI (15% Multiplier)", " Fixed Allocations"]
    },
    [InvestmentValues.Aggressive]: {
        codes: ["86", "125", "124", "123"],
        labels: ["PIMCO Select (40% Multiplier)", " Blended Futures Select (40% Multiplier)", " S&P Futures Select (40% Multiplier)", " BUDBI Select (40% Multiplier)"]
    },
    [InvestmentValues.AggressivePlus]: {
        codes: ["86", "125", "124", "123", "3"],
        labels: ["PIMCO Select (40% Multiplier)", " Blended Futures Select (40% Multiplier)", " S&P Futures Select (40% Multiplier)", " BUDBI Select (40% Multiplier)", " Fixed Allocations"]
    },
}

export function isALGCarrier(carrierId:any){
    const carrierCode = getCarrierCode(carrierId);
    return carrierCode == "ALZ"
}

export const distributionLoanRate = (growthRate: number, carrierId: number, minimumLoanRate = 5.50) =>{
    const result = growthRate - 0.50
    if(isALGCarrier(carrierId)){
        return result
    }
    if(result > 8){
        return 8.00
    } else if (result < minimumLoanRate){
        return minimumLoanRate
    }
    return result
}
export function calculateGrowthRate(allocations){
    // const defaultPercentage = allocations && (100 / allocations.length)
    const growthRate = allocations && allocations.reduce((total, question) => {
        return (Number(question && question.allocationrate) * Number(question && question.allocationweight)/100) + total
    }, 0)
    return growthRate && growthRate.toFixed(2)
}

export const ALZInterestPayload =[
    {
        "allocations": [
            {
                "allocationname": "100",
                "allocationrate": 6.74,
                "allocationweight": 100
            }
        ],
        "from": "1",
        "through": "M"
    }
]

export const stressAllocationForALZ =  [
        {
            "allocations": [
                {
                    "allocationname": "101",
                    "allocationrate": 0,
                    "allocationweight": 25
                },
                {
                    "allocationname": "131",
                    "allocationrate": 0,
                    "allocationweight": 25
                },
                {
                    "allocationname": "130",
                    "allocationrate": 0,
                    "allocationweight": 25
                },
                {
                    "allocationname": "129",
                    "allocationrate": 0,
                    "allocationweight": 25
                }
            ],
            "from": "1",
            "through": "5"
        },
        {
            "allocations": [
                {
                    "allocationname": "101",
                    "allocationrate": 6.65,
                    "allocationweight": 25
                },
                {
                    "allocationname": "131",
                    "allocationrate": 6.65,
                    "allocationweight": 25
                },
                {
                    "allocationname": "130",
                    "allocationrate": 6.65,
                    "allocationweight": 25
                },
                {
                    "allocationname": "129",
                    "allocationrate": 6.65,
                    "allocationweight": 25
                }
            ],
            "from": "6",
            "through": "7"
        },
        {
            "allocations": [
                {
                    "allocationname": "101",
                    "allocationrate": 0,
                    "allocationweight": 25
                },
                {
                    "allocationname": "131",
                    "allocationrate": 0,
                    "allocationweight": 25
                },
                {
                    "allocationname": "130",
                    "allocationrate": 0,
                    "allocationweight": 25
                },
                {
                    "allocationname": "129",
                    "allocationrate": 0,
                    "allocationweight": 25
                }
            ],
            "from": "8",
            "through": "8"
        },
        {
            "allocations": [
                {
                    "allocationname": "101",
                    "allocationrate": 6.65,
                    "allocationweight": 25
                },
                {
                    "allocationname": "131",
                    "allocationrate": 6.65,
                    "allocationweight": 25
                },
                {
                    "allocationname": "130",
                    "allocationrate": 6.65,
                    "allocationweight": 25
                },
                {
                    "allocationname": "129",
                    "allocationrate": 6.65,
                    "allocationweight": 25
                }
            ],
            "from": "9",
            "through": "M"
        }
    ];

// export const stressAllocationsData = [
//     {
//         "allocations": [
//             {
//                 "allocationname": "BalancedTrendIndexPointToPointNoCap",
//                 "allocationrate": 0,
//                 "allocationweight": 50
//             },
//             {
//                 "allocationname": "USPacesetterIndexPointtoPointNoCap",
//                 "allocationrate": 0,
//                 "allocationweight": 50
//             }
//         ],
//         "from": "1",
//         "through": "5"
//     },
//     {
//         "allocations": [
//             {
//                 "allocationname": "BalancedTrendIndexPointToPointNoCap",
//                 "allocationrate": 6.44,
//                 "allocationweight": 50
//             },
//             {
//                 "allocationname": "USPacesetterIndexPointtoPointNoCap",
//                 "allocationrate": 6.44,
//                 "allocationweight": 50
//             }
//         ],
//         "from": "6",
//         "through": "7"
//     },
//     {
//         "allocations": [
//             {
//                 "allocationname": "BalancedTrendIndexPointToPointNoCap",
//                 "allocationrate": 0,
//                 "allocationweight": 50
//             },
//             {
//                 "allocationname": "USPacesetterIndexPointtoPointNoCap",
//                 "allocationrate": 0,
//                 "allocationweight": 50
//             }
//         ],
//         "from": "8",
//         "through": "8"
//     },
//     {
//         "allocations": [
//             {
//                 "allocationname": "BalancedTrendIndexPointToPointNoCap",
//                 "allocationrate": 6.44,
//                 "allocationweight": 50
//             },
//             {
//                 "allocationname": "USPacesetterIndexPointtoPointNoCap",
//                 "allocationrate": 6.44,
//                 "allocationweight": 50
//             }
//         ],
//         "from": "9",
//         "through": "9"
//     },
//     {
//         "allocations": [
//             {
//                 "allocationname": "BalancedTrendIndexPointToPointNoCap",
//                 "allocationrate": 0,
//                 "allocationweight": 50
//             },
//             {
//                 "allocationname": "USPacesetterIndexPointtoPointNoCap",
//                 "allocationrate": 0,
//                 "allocationweight": 50
//             }
//         ],
//         "from": "10",
//         "through": "12"
//     },
//     {
//         "allocations": [
//             {
//                 "allocationname": "BalancedTrendIndexPointToPointNoCap",
//                 "allocationrate": 6.44,
//                 "allocationweight": 50
//             },
//             {
//                 "allocationname": "USPacesetterIndexPointtoPointNoCap",
//                 "allocationrate": 6.44,
//                 "allocationweight": 50
//             }
//         ],
//         "from": "13",
//         "through": "M"
//     }
// ]

export const stressAllocationsData = [
    {
        "allocations": [
            {
                "allocationname": "BalancedTrendIndexPointToPointNoCap",
                "allocationrate": 0,
                "allocationweight": 50
            },
            {
                "allocationname": "USPacesetterIndexPointtoPointNoCap",
                "allocationrate": 0,
                "allocationweight": 50
            }
        ],
        "from": "1",
        "through": "5"
    },
    {
        "allocations": [
            {
                "allocationname": "BalancedTrendIndexPointToPointNoCap",
                "allocationrate": 6.81,
                "allocationweight": 50
            },
            {
                "allocationname": "USPacesetterIndexPointtoPointNoCap",
                "allocationrate": 6.81,
                "allocationweight": 50
            }
        ],
        "from": "6",
        "through": "7"
    },
    {
        "allocations": [
            {
                "allocationname": "BalancedTrendIndexPointToPointNoCap",
                "allocationrate": 0,
                "allocationweight": 50
            },
            {
                "allocationname": "USPacesetterIndexPointtoPointNoCap",
                "allocationrate": 0,
                "allocationweight": 50
            }
        ],
        "from": "8",
        "through": "8"
    },
    {
        "allocations": [
            {
                "allocationname": "BalancedTrendIndexPointToPointNoCap",
                "allocationrate": 6.81,
                "allocationweight": 50
            },
            {
                "allocationname": "USPacesetterIndexPointtoPointNoCap",
                "allocationrate": 6.81,
                "allocationweight": 50
            }
        ],
        "from": "9",
        "through": "9"
    },
    {
        "allocations": [
            {
                "allocationname": "BalancedTrendIndexPointToPointNoCap",
                "allocationrate": 0,
                "allocationweight": 50
            },
            {
                "allocationname": "USPacesetterIndexPointtoPointNoCap",
                "allocationrate": 0,
                "allocationweight": 50
            }
        ],
        "from": "10",
        "through": "12"
    },
    {
        "allocations": [
            {
                "allocationname": "BalancedTrendIndexPointToPointNoCap",
                "allocationrate": 6.81,
                "allocationweight": 50
            },
            {
                "allocationname": "USPacesetterIndexPointtoPointNoCap",
                "allocationrate": 6.81,
                "allocationweight": 50
            }
        ],
        "from": "13",
        "through": "M"
    }
];

export const findPaymentMethodInPolicy = (policy: any, method = "ePay") =>{
    if(policy && policy.clientPayments && Array.isArray(policy.clientPayments)){
       return policy.clientPayments.find((payments:any) =>{
            return payments.type === method;
        })
    }
    return false
}


